export const SET_STAGE = "SET_STAGE";
export const EXPORT_REQUEST = "EXPORT_REQUEST";
export const EXPORT_SUCCESS = "EXPORT_SUCCESS";
export const EXPORT_ERROR = "EXPORT_ERROR";

export const IMPORT_REQUEST = "IMPORT_REQUEST";
export const IMPORT_SUCCESS = "IMPORT_SUCCESS";
export const IMPORT_ERROR = "IMPORT_ERROR";
